import { AnimationMixer, Box3, Group, Object3D, Vector3 } from "three";
import { GLBModel } from "./GLBModel";

export class SkimmerModel extends GLBModel {
  constructor() {
    super("/models/weapon/skimmer.glb");
  }

  get key(): string {
    return "skimmer";
  }

  /**
   * Как в donmccurdy/three-gltf-viewer `setContent`: AABB → сдвиг корня, чтобы пивот был у центра.
   * Внешний `Group` с identity-трансформом — сюда в сцене вешают смещение от камеры, не затирая центрирование.
   */
  getModel(): Object3D | null {
    const scene = super.getModel();

    if (!scene) {
      return null;
    }

    scene.updateMatrixWorld(true);
    const center = new Box3().setFromObject(scene).getCenter(new Vector3());
    scene.position.sub(center);

    const hudRoot = new Group();
    hudRoot.add(scene);

    hudRoot.traverse((obj) => {
      obj.frustumCulled = false;
      obj.layers.set(1);
    });

    return hudRoot;
  }

  /**
   * Первый клип GLB на клоне сцены. Требуется {@link GLBModel.getModel} через
   * `SkeletonUtils.clone`, иначе скелет смотрит на кости оригинала и микшер не деформирует меш.
   */
  createHudAnimationDriver(hudRoot: Object3D): {
    update: (dt: number) => void;
    dispose: () => void;
  } | null {
    const gltf = this.gltf;

    if (!gltf?.animations?.length) {
      return null;
    }
    const inner = hudRoot.children[0];
    if (!inner) {
      return null;
    }

    const mixer = new AnimationMixer(inner);
    const action = mixer.clipAction(gltf.animations[0]);
    action.play();

    return {
      update: (dt: number) => {
        mixer.update(dt);
      },
      dispose: () => {
        action.stop();
        mixer.stopAllAction();
      }
    };
  }
}
